export default __webpack_public_path__ + "static/media/tennisicon.79f46324.png";